import React from 'react';
import { BookHeart, Home, Briefcase, Smartphone, DollarSign, Brain, Sparkles, Baby, Gift } from 'lucide-react';
type Category = {
  title: string;
  icon: React.ReactNode;
  color: string;
  items: string[];
};
const categories: Category[] = [{
  title: 'Personal Development',
  icon: <BookHeart className="w-6 h-6" data-id="element-39" />,
  color: 'bg-pink-100 text-pink-600',
  items: ['Self-Care Planner', 'Life Planner', 'Manifestation Planner', 'Self-Love Planner', 'Self-Confidence Planner', 'Personal Growth Planner', 'Mood Trackers', 'Introvert Journal', 'Find Your Passion', 'Reading Planner', 'Switch Off Journal']
}, {
  title: 'Home & Living',
  icon: <Home className="w-6 h-6" data-id="element-40" />,
  color: 'bg-green-100 text-green-600',
  items: ['Rental Property Planner', 'Relocation Planner', 'Household Management', 'Home Buying Planner', 'Garden Planner', 'Decluttering & Cleaning', 'Pet Care Planner', 'Home Renovation', 'Moving Planner', 'Recipe Journal']
}, {
  title: 'Business & Career',
  icon: <Briefcase className="w-6 h-6" data-id="element-41" />,
  color: 'bg-blue-100 text-blue-600',
  items: ['Small Business Planner', 'Digital Product Planner', 'Shop Planner', 'Shopify Planner', 'Product Launch Planner', 'Order Forms Bundle', 'Handmade Business', 'Side Hustle Planner', 'Project Management']
}, {
  title: 'Social Media',
  icon: <Smartphone className="w-6 h-6" data-id="element-42" />,
  color: 'bg-purple-100 text-purple-600',
  items: ['Social Media Post Planner', 'Monthly Content Planner', 'Marketing Bundle', 'Instagram Grid Planner', 'Content Strategy', 'Hashtag Tracker', 'Analytics Tracker', 'Brand Kit Template']
}, {
  title: 'Financial Freedom',
  icon: <DollarSign className="w-6 h-6" data-id="element-43" />,
  color: 'bg-yellow-100 text-yellow-600',
  items: ['Budget Trackers', 'Debt Trackers', 'Credit Trackers', 'Savings Challenges', 'Financial Planner', 'Rainbow Budget', 'Investment Tracker', 'Expense Log', 'Bill Payment Calendar']
}, {
  title: 'Mental Health',
  icon: <Brain className="w-6 h-6" data-id="element-44" />,
  color: 'bg-teal-100 text-teal-600',
  items: ['ADHD Planner', 'Deep Mental Prompts (115)', 'Anxiety Journal', 'Depression Therapy', 'PTSD Workbook', 'Safety & Crisis Plan', 'Stress Processing', 'Self-Reflective Prompts']
}, {
  title: 'Spirituality',
  icon: <Sparkles className="w-6 h-6" data-id="element-45" />,
  color: 'bg-indigo-100 text-indigo-600',
  items: ['Prayer Journal', 'Manifestation Dream Life', 'Abundance Mindset', 'Faith-Based Journal', 'Law of Attraction', 'Gratitude Journal', 'Spiritual Awakening', 'Tarot Bundle', 'Witchy Planner']
}, {
  title: 'Kids & Family',
  icon: <Baby className="w-6 h-6" data-id="element-46" />,
  color: 'bg-orange-100 text-orange-600',
  items: ['Pregnancy Journal', 'Baby Memory Book', 'Newborn Planner', "Mom's Planner", 'Baby Shower Notebook', 'Teacher Planner', 'Summer Planner for Kids', 'Daily Journal for Kids']
}, {
  title: 'Bonus Bundles',
  icon: <Gift className="w-6 h-6" data-id="element-47" />,
  color: 'bg-red-100 text-red-600',
  items: ['8,000+ Digital Stickers', 'Camping Journal', 'Medical Logbook', 'Weight Loss Tracker', 'Diabetes Tracker', 'Stop Smoking Planner', 'Mileage Tracker', 'To-Do List Notebook']
}];
export function ProductList() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-48">
      {categories.map((category, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow border border-gray-100" data-id="element-49">
          <div className="flex items-center gap-3 mb-4" data-id="element-50">
            <div className={`p-3 rounded-xl ${category.color}`} data-id="element-51">
              {category.icon}
            </div>
            <h3 className="font-bold text-lg text-gray-800" data-id="element-52">
              {category.title}
            </h3>
          </div>

          <ul className="space-y-2" data-id="element-53">
            {category.items.map((item, i) => <li key={i} className="text-gray-600 text-sm flex items-start gap-2" data-id="element-54">
                <span className="text-pink-400 mt-1" data-id="element-55">•</span>
                {item}
              </li>)}
          </ul>

          <div className="mt-4 pt-4 border-t border-gray-100 text-center" data-id="element-56">
            <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-57">
              And much more
            </span>
          </div>
        </div>)}
    </div>;
}